import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyBmqVPCf3Qx75DbXagWGYv4Pk8fXN85-LY",
    authDomain: "nichewarelandingcontactform.firebaseapp.com",
    projectId: "nichewarelandingcontactform",
    storageBucket: "nichewarelandingcontactform.firebasestorage.app",
    messagingSenderId: "103711001477",
    appId: "1:103711001477:web:7e858cb00e5b92aff312ec",
    measurementId: "G-B3FS6CL0LG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
const analytics = getAnalytics(app);
const functions = getFunctions(app);

export {
    app,
    analytics,
    functions
};